export const hierarchyResponse = (hierarchyResponse = null, action) => {
    if (action.type === "FETCH_HIERARCHY_RESPONSE") {
        return action.payload;
    }
    if (action.type === "RESET_HIERARCHY") {
        return null;
    }
    return hierarchyResponse;
};
